import {Stack, Tooltip} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import React from 'react'
import {useTranslation} from 'react-i18next'
import Label from '../customTable/Label'
import FixedNumber from '../customTable/FixedNumber'

export default function Card({data, bgcolor}: any) {
  const {t} = useTranslation()

  return (
    <Stack
      bgcolor={bgcolor}
      width={{lg: 'calc(25% - 24px)', sm: 'calc(50% - 16px)', xs: '100%'}}
      minWidth={'226px'}
      p='16px 24px'
      border='1px solid #E8E8E8'
      borderRadius={'12px'}
      gap='24px'
    >
      <Stack direction='row' alignItems='center' gap='6px'>
        <Label fw='600' fs='14px' color='#6A647D' text={data.name} />
        {data.tooltip && (
          <Tooltip title={t(data.tooltip)} arrow placement='top'>
            <InfoOutlinedIcon
              sx={{fontSize: 16, color: '#6A647D', cursor: 'help'}}
              aria-label={t(data.tooltip)}
            />
          </Tooltip>
        )}
      </Stack>
      <FixedNumber color='#3F4254' fs='32px' fw='700' num={data.value} />
    </Stack>
  )
}
